module.exports = function getResource(label) {
    let resources = {
        sameDayDelivery: 'Same-Day Delivery ',
        standard: 'Standard ',
        item: 'Item',
        items: 'Items'
    };

    return resources[label];
};
